import { Menu, MenuProps } from '@mui/material';
import { useContext, useMemo } from 'react';
import { ExpandableSection } from './ExpandableSection';
import { ReportTypeRadioGroup } from './ReportTypeRadioGroup';
import { CampaignTypeRadioGroup } from './CampaignTypeRadioGroup';
import { SearchableList } from './SearchableList';
import {
  FilterParams,
  SelectableItem,
} from '@features/campaign-list/domain/filter';
import { FilterContext } from '@features/campaign-list/stores/filter-context';
import { useClients } from '@features/clients';
import { ClientSelect } from './ClientSelect';
import { groupBy } from 'lodash';
import { useCurrentUser } from '@features/users';

type PopupProps = {
  anchorEl: MenuProps['anchorEl'];
  open: MenuProps['open'];
  onClose: MenuProps['onClose'];
};

export const Popup = (props: PopupProps) => {
  const { filterState, dispatch } = useContext(FilterContext);
  const { isLoading, clients } = useClients();
  const { userType } = useCurrentUser();

  const clientsById = useMemo(() => groupBy(clients, 'id'), [clients]);
  const availableAdvertisers = filterState.selectedClient
    ? clientsById[filterState.selectedClient.id][0].advertisers
    : [];

  const showClientSelect = userType !== 'partner';

  const handleClientToggle = (value: FilterParams['selectedClient']) => {
    dispatch({ type: 'client_selected', payload: value });
  };

  const handleAdvertiserToggle = (value: SelectableItem) => {
    dispatch({ type: 'advertiser_toggled', payload: value });
  };

  return (
    <Menu anchorEl={props.anchorEl} open={props.open} onClose={props.onClose}>
      <ExpandableSection title="Campaign Type" defaultExpanded>
        <CampaignTypeRadioGroup />
      </ExpandableSection>
      <ExpandableSection title="Report Type">
        <ReportTypeRadioGroup />
      </ExpandableSection>
      {showClientSelect ? (
        <ExpandableSection title="Organization">
          <ClientSelect
            onChange={handleClientToggle}
            clients={clients}
            isLoading={isLoading}
            value={filterState.selectedClient}
          />
        </ExpandableSection>
      ) : null}
      {userType === 'partner' ? null : (
        <ExpandableSection title="Advertiser">
          <SearchableList
            checkedItems={filterState.checkedAdvertisers}
            items={availableAdvertisers}
            placeholder="Advertiser"
            onListToggle={handleAdvertiserToggle}
            noDataMessage="No client selected"
          />
        </ExpandableSection>
      )}
    </Menu>
  );
};
